import React from 'react';
import styled from 'styled-components';
import FoldersBreadcrumbsItem from './components/FoldersBreadcrumbsItem';

const StyledNavContainer = styled.div`
  display: flex;
  background-color: ${props => props.theme.colors.light_darker};
  border-bottom: 2px solid ${props => props.theme.colors.light_darker_1};
  padding: 0 8px 0 0;
  height: 48px;
  position: sticky;
  top: 0;
  z-index: 2;
`;

const FoldersBreadcrumbs = ({ navigation, onNavigationClick }) => {
  if (navigation.length <= 1) {
    return false;
  }

  return (
    <StyledNavContainer>
      {navigation.map((nav, index) => {
        return (
          <FoldersBreadcrumbsItem
            key={`nav-item-${index}-${nav.id}`}
            nav={nav}
            index={index}
            islastButOne={index === navigation.length - 2}
            last={index === navigation.length - 1}
            onNavigationClick={onNavigationClick}
          />
        );
      })}
    </StyledNavContainer>
  );
};

FoldersBreadcrumbs.defaultProps = {
  navigation: [],
};

export default FoldersBreadcrumbs;
